import React, { useState } from "react"

import { hideVisually } from "polished"
import styled, { css } from "styled-components"
import Link from "../animatedLink"
import { Transition } from "react-transition-group"

import navData from "./navData"
import Logo from "../../images/tryhard-japan-tiger.inline.svg"
import ReturnArrow from "../../images/return.inline.svg"
import SocialMedia from "../socialMedia"

export default ({ opened, toggle, animationState }) => {
  const [subMenu, setSubMenu] = useState("")

  // const toggleBusiness = e => {
  //   e.target.parentNode.classList.toggle("is-active")
  //   setSubMenu(!subMenu)
  // }

  // const toggleCompany = e => {
  //   e.target.parentNode.classList.toggle("is-active")
  //   setSubMenu(!subMenu)
  // }

  const resetMenu = e => {
    setSubMenu("")
    toggle()
  }

  const links = navData().map(item => (
    <TopMenuListItem key={item.to}>
      {!item.isSubMenu ? (
        <TopMenuLink to={item.to} onClick={resetMenu}>
          {item.label}
        </TopMenuLink>
      ) : (
        <>
          <SubMenuToggle onClick={() => setSubMenu(item.subMenuSlug)}>
            {item.label}
          </SubMenuToggle>
          <SubMenuContainer opened={subMenu === item.subMenuSlug}>
            <SubMenuHeading>{item.label}</SubMenuHeading>
            <SubMenu>
              {item.subMenu.map(subItem => (
                <SubMenuListItem key={subItem.to}>
                  <SubMenuLink
                    to={`${item.to}${subItem.to}`}
                    onClick={resetMenu}
                  >
                    {subItem.label}
                  </SubMenuLink>
                </SubMenuListItem>
              ))}
            </SubMenu>
          </SubMenuContainer>
        </>
      )}
    </TopMenuListItem>
  ))

  return (
    <>
      <Toggle onClick={resetMenu} className={`state-${animationState}`}>
        <ToggleBars opened={opened}>
          <span>メニュー</span>
        </ToggleBars>
      </Toggle>
      <Transition
        timeout={{ enter: 0, exit: 500 }}
        mountOnEnter
        unmountOnExit
        in={opened}
      >
        {state => <Overlay onClick={resetMenu} className={`state-${state}`} />}
      </Transition>
      {/* {opened && <Overlay onClick={resetMenu} />} */}
      <Nav opened={opened} animationState={animationState}>
        {subMenu !== "" && <SubMenuOverlay onClick={() => setSubMenu("")} />}
        <Transition
          timeout={{ enter: 0, exit: 500 }}
          mountOnEnter
          unmountOnExit
          in={subMenu !== ""}
        >
          {state => (
            <CloseSubMenu
              onClick={() => setSubMenu("")}
              className={`state-${state}`}
            >
              <span>Back</span>
              <ReturnArrow />
            </CloseSubMenu>
          )}
        </Transition>
        <TopMenuContainer>
          <TopMenu>
            <LogoContainer>
              <Logo />
            </LogoContainer>
            {links}
          </TopMenu>

          <SocialMedia />
        </TopMenuContainer>
      </Nav>
    </>
  )
}

const Toggle = styled.button`
  position: fixed;
  z-index: 101;
  right: 0;
  top: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0 0 0.5rem 0;
  border: 0;
  outline: none;
  background: ${({ theme }) => theme.colors.accent};
  transition: background 0.25s, opacity 0.5s, transform 0.25s;

  &.state-entering {
    transform: translate(100%, -100%);
  }
  &.state-entered {
    transform: translate(0, 0);
  }
  &.state-exiting {
    transform: translate(100%, -100%);
  }
  &.state-exited {
    transform: translate(100%, -100%);
  }

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 100vw;
    background: ${({ theme }) => theme.colors.accent};
    transform-origin: center bottom;
    transform: translateX(-50%) rotate(40deg);
    transition: background 0.25s;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.contrast};

    &::before {
      background: ${({ theme }) => theme.colors.contrast};
    }
  }
`

const ToggleBars = styled.span`
  padding: 0;
  position: relative;
  right: 1rem;

  transform-origin: left bottom;

  &,
  &::before,
  &::after {
    display: block;
    width: 1.25rem;
    height: 3px;
    background: ${({ theme }) => theme.colors.main};
    border-radius: 3px;
    transition: transform 0.5s, opacity 0.75s;
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 0;
  }

  &::before {
    bottom: -6px;
  }
  &::after {
    bottom: -12px;
    transition: transform 0.75s;
    transform-origin: left top;
  }

  span {
    ${hideVisually()}
  }

  ${({ opened }) =>
    opened &&
    css`
      transform: rotate(45deg);

      &::after {
        transform: rotate(-90deg) translateY(0.5rem);
      }
      &::before {
        opacity: 0;
        transform: translate(-400%, 100%);
      }
    `}
`

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  -webkit-backdrop-filter: blur(1.5rem);
  backdrop-filter: blur(1.5rem);
  transition: opacity 0.5s;

  &.state-entering {
    opacity: 0;
  }
  &.state-entered {
    opacity: 1;
  }
  &.state-exiting {
    opacity: 0;
  }
  &.state-exited {
    opacity: 0;
  }
`

const Nav = styled.nav`
  position: fixed;
  z-index: 100;
  right: 0;
  top: 0;
  width: 90vw;
  max-width: 500px;
  height: 100vh;
  background: ${({ theme }) => theme.colors.accent};
  transform: translateX(100%);
  transition: 0.25s transform;

  ${({ opened }) =>
    opened &&
    css`
      transform: translateX(0);
    `}

  ${({ animationState }) =>
    animationState === "entering" &&
    css`
      opacity: 0;
    `}
  ${({ animationState }) =>
    animationState === "entered" &&
    css`
      opacity: 1;
    `}
  ${({ animationState }) =>
    animationState === "exiting" &&
    css`
      opacity: 0;
    `}
  ${({ animationState }) =>
    animationState === "exited" &&
    css`
      opacity: 0;
    `}
`

const TopMenuContainer = styled.div`
  height: 100vh;
  padding: 0 0 3rem 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

const TopMenu = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  font-size: 1.5rem;
  font-weight: 200;
`

const TopMenuListItem = styled.li`
  margin-bottom: 0.25rem;
`

const TopMenuLink = styled(Link)`
  color: ${({ theme }) => theme.colors.main};
  text-decoration: none;
`

const SubMenuToggle = styled.button`
  padding: 0;
  border: 0;
  color: ${({ theme }) => theme.colors.main};
  text-decoration: none;
`

const SubMenuOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  width: 100vw;
  height: 100vh;
`

const SubMenuContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  width: calc(90vw - 2rem);
  max-width: calc(500px - 2rem);
  height: 100vh;
  padding: 3rem 0 3rem 0;
  transform: translateX(100%);
  transition: 0.25s transform;
  background: ${({ theme }) => theme.colors.contrast};
  color: ${({ theme }) => theme.colors.main};
  overflow: auto;

  ${({ opened }) =>
    opened &&
    css`
      transform: translateX(0);
    `}
`

const SubMenuHeading = styled.h4`
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
`

const SubMenu = styled(TopMenu)`
  font-size: 1.25rem;
`

const SubMenuListItem = styled(TopMenuListItem)``
const SubMenuLink = styled(TopMenuLink)``

const CloseSubMenu = styled.button`
  position: absolute;
  top: 1rem;
  left: 3rem;
  z-index: 3;
  width: 1.15rem;
  height: 1.15rem;
  padding: 0;
  border: 0;
  outline: none;
  transition: opacity 0.25s, transform 0.25s;

  &.state-entering {
    opacity: 0;
    transform: translateY(-2.15rem);
  }
  &.state-entered {
    opacity: 1;
    transform: translateY(0);
  }
  &.state-exiting {
    opacity: 0;
    transform: translateY(-2.15rem);
  }

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 200%;
    height: 200%;
    transform: translate(-50%, -50%);
  }

  svg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  span {
    ${hideVisually()}
  }
`

const LogoContainer = styled.li`
  position: relative;
  width: 5.5rem;
  height: 5.5rem;
  margin: 2rem auto;
  background: white;
  border-radius: 50%;

  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }

  svg {
    position: absolute;
    left: 50%;
    top: 56%;
    transform: translate(-50%, -50%);
    width: 85%;
  }
`
